module.exports = __webpack_public_path__ + "img/5.1493d120.jpg";